import largeBanner from '../../assets/bannerImages/L.webp'
import mediumBanner from '../../assets/bannerImages/M.webp'
import smallBanner from '../../assets/bannerImages/S.webp'

import { SPECIAL_TEMPLATES } from '../../helpers/templateConfig/templateConfig'

const chineseConfig = {
  banners: {
    small: smallBanner,
    medium: mediumBanner,
    large: largeBanner,
  },

  // Add special templates that this site wants beyond the defaults
  additionalTemplates: [
    SPECIAL_TEMPLATES.CHINESE_SURNAME, // Template 2: Chinese surname page
    SPECIAL_TEMPLATES.FAMILY_TREE, // Template 16: Family tree design
    SPECIAL_TEMPLATES.GLOBAL_SURNAME, // Template 17: Global surname page
    SPECIAL_TEMPLATES.FAN_CHART, // Template 20: Fan Chart page
  ],

  // Ordered list of template IDs for the layout picker (non-front pages)
  // Templates not listed here appear at the end in numeric order
  templateOrder: [
    19, // Create Your Own (Blank)
    18, // Back page
    1,
    3,
    4, // Front cover pages
    2, // Chinese surname
    17, // Global surname
    16, // Family tree design
    20, // Fan chart
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15, // Content layouts
  ],
}

export default chineseConfig
